/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { LogoutCommand } from './logout.command';
import { LogoutService } from '../../../../core/security/components/logout/logout.service';

export function logoutFactory() {
    const command = new LogoutCommand();
    command.setDependencies({
        logoutService: inject(LogoutService)
    });
    return command;
}
